const AuctionEntryPending = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-8">
      <div>
        <img src="/search-1.gif" className="h-48" />
      </div>

      <div>
        <p className="text-base font-bold text-center">
          Este leilão ainda não foi iniciado
        </p>
      </div>
    </div>
  );
}

export default AuctionEntryPending;
